export const Redirector = {
  redirect(url: string) {
    window.location.href = url;
  },

  redirectToNuveiPaymentPage(url: string) {
    const parsedUrl = new URL(url);
    const actionUrl = parsedUrl.origin + parsedUrl.pathname;

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = actionUrl;
    form.style.display = 'none';

    parsedUrl.searchParams.forEach((value, key) => {
      if (key) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value || '';
        form.appendChild(input);
      }
    });

    document.body.appendChild(form);
    window.history.replaceState(null, '', parsedUrl.searchParams.get('back_url'));
    form.submit();
  }
};
